import React, {createContext, useState} from "react";
import PropTypes from "prop-types";

export const PageContext = createContext({});

export const PageProvider = props => {
  // Initial values are obtained from the props
  const {
    action,
    signedParams: initialSignedParams,
    csrfSymfony,
    captcha,
    children,
  } = props;


  // Use State to keep the values
  const [signedParams, updateSignedParams] = useState(initialSignedParams);

  // Make the context object:
  const pageContext = {
    action,
    signedParams,
    updateSignedParams,
    csrfSymfony,
    captcha
  };

  // pass the value in provider and return
  return <PageContext.Provider value={pageContext}>{children}</PageContext.Provider>;
};

export const {Consumer} = PageContext;

PageProvider.propTypes = {
  action: PropTypes.string,
  signedParams: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  captcha: PropTypes.object,
};

PageProvider.defaultProps = {
  action: 'preferences',
  signedParams: {},
  csrfSymfony: {},
  captcha: {},
};
